// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"c0d499b4","523":"9458e3c9","779":"ac478d7a","958":"c4dd6553"}[chunkId] + ".css";
};